const ValidationErrorMessages = {
  claimReferenceRequired: "All searches must include a claim reference.",
  optionalFieldsRequired: "At least one of the optional fields is required.",
  invalidEmail: "Only an email address is allowed.",
  invalidPhone: "Only a telephone number is allowed.",
  invalidNI: "Only a National Insurance number is allowed.",
  invalidOrganisation:
    "Organisation name and postcode, or Companies House number, or GMC number is required.",
  invalidVehicle: "Only a vehicle registration number is allowed.",
  invalidPassport: "Only a passport number is allowed.",
  invalidPerson:
    "A forename and surname with either an email, NI number, driving license, vehicle registration, VIN, telephone number, or passport number is required.",
  invalidAddress: "Only an address is allowed.",
  invalidDrivingLicense: "Only a driver's license number is allowed.",
  invalidPersonAddress:
    "A forename and surname with both an address and date of birth are required.",
};

export default ValidationErrorMessages;
